import * as React from 'react';
import styled, { css } from 'styled-components';

import { media } from '../../../styles/theme';
import { Flex } from '../../common/Flex';
import { Icon } from '../../common/Icon';
import { Indent } from '../../common/Indent';
import { StyledText } from '../../common/StyledText';
import { useTheme } from '../../../hooks/useTheme';

interface IProps {
  icon: string;
  title: React.ReactNode;
  description: React.ReactNode;
  withChain?: boolean;
  isEven?: boolean;
}
export const PartnerInfoBlock: React.FC<IProps> = ({ icon, title, description, withChain, isEven }) => {
  const theme = useTheme();
  return (
    <Root>
      <Indent around={1.5}>
        <Flex align='center' wrap='nowrap'>
          <Indent right={1}>
            <Icon name={icon} width='1.5rem' color={theme.primaryColor} />
          </Indent>
          <h3>
            <Title>{title}</Title>
          </h3>
        </Flex>
        <Indent top={1}>
          <StyledText color='textSecondary'>{description}</StyledText>
        </Indent>
      </Indent>
      {withChain && (
        <Chain isEven={isEven}>
          <svg width='20px' height='17px' viewBox='0 0 20 17'>
            <path
              strokeDasharray='2,4'
              d='M3.97903932e-13,16 C6.44731117,16 11.1445855,13.7887106 14.5795919,8.87836287 C16.7352776,5.79680641 19,1.04609908 19,-3'
              fill='none'
              stroke={theme.primaryColor}
              strokeWidth='2'
            />
          </svg>
        </Chain>
      )}
    </Root>
  );
};

const Root = styled.div`
  background: ${p => p.theme.componentDarkColor};
  box-shadow: 0 5px 34px 0 rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  color: ${p => p.theme.textInvertedColor};
  display: flex;
  position: relative;
  height: 100%;
  margin-right: 10px;
  margin-left: 10px;
  margin-bottom: 20px;

  ${media.md`
    margin-left: 20px;
    margin-right: 0px;
    margin-bottom: 0;
  `};
`;

const Title = styled.div`
  flex-basis: 100%;
  flex-shrink: 1;
  text-transform: uppercase;
  font-weight: 300;
  letter-spacing: 2px;
  line-height: 28px;
  font-size: 0.8em;
`;

const applyChainStyles = ({ isEven }) => css`
  ${isEven ? 'left' : 'right'}: -20px;
  transform: rotate(${!isEven ? '310' : '130'}deg);

  ${media.sm`
    right: -20px;
    left: auto;
    transform: rotate(0deg);
  `}
`;

const Chain = styled.div`
  position: absolute;
  bottom: -20px;
  transform: rotate(310deg);
  ${applyChainStyles};

  .rtl & {
    transform: rotate(75deg);
  }

  ${media.sm`visibility: hidden;`};
  ${media.md`
    visibility: visible;
    transform: rotate(0);
    bottom: 5px;
    right: -30px;

		.rtl & {
			left: -30px;
			right: auto;
		}
    `};
`;
